/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import moment from "moment";
import "moment/locale/tr";
import { FaLock, FaCheck, FaStar } from "react-icons/fa";

import { API } from "@services/http.service";

moment.locale("tr");

const CONDITION_LABELS = {
  LOGIN_COUNT: "gün giriş",
  ACTION_COUNT: "aksiyon",
  PURCHASE_COUNT: "alışveriş",
};

const STATE_STYLE = {
  EARNED: { border: "#e8eaed", bg: "#fafbfc", opacity: 0.75, badge: { text: "✓ Tamamlandı", bg: "#E8F5E9", color: "#1B5E20" } },
  ACTIVE: { border: "#1B5E7B", bg: "#EBF5FB", opacity: 1, badge: { text: "Devam Ediyor", bg: "#EBF5FB", color: "#1B5E7B" } },
  LOCKED: { border: "#e8eaed", bg: "#f5f5f5", opacity: 0.55, badge: { text: "Kilitli", bg: "#f0f2f5", color: "#94a3b8" } },
  MISSED: { border: "#FFCDD2", bg: "#FEF2F2", opacity: 0.7, badge: { text: "Kaçırıldı", bg: "#FFEBEE", color: "#C62828" } },
};

// Kademenin dönem ay aralığı, örn. "Temmuz-Eylül".
// Dönem [başlangıç, bitiş) mantığında: bitiş ayın 1'i ise o gün dâhil değildir,
// bu yüzden önceki ay yazılır (1 Tem - 1 Eki => "Temmuz-Eylül").
const monthRange = (tier) => {
  if (!tier.periodBegin || !tier.periodEnd) return "";
  const begin = moment(tier.periodBegin).format("MMMM");
  const endM = moment(tier.periodEnd);
  const end = (endM.date() === 1 ? endM.clone().subtract(1, "day") : endM).format("MMMM");
  return `${begin}-${end}`;
};

const TierCard = ({ tier, onClick, fallbackImage }) => {
  const style = STATE_STYLE[tier.state] || STATE_STYLE.LOCKED;
  const months = monthRange(tier);
  const img = tier.imageUrl || fallbackImage; // kademe görseli yoksa ana rozet görseli
  return (
    <button
      type="button"
      onClick={onClick}
      style={{
        textAlign: "center",
        padding: "16px 10px",
        borderRadius: 10,
        border: `2px solid ${style.border}`,
        background: style.bg,
        opacity: style.opacity,
        position: "relative",
        cursor: "pointer",
        width: "100%",
      }}
    >
      {tier.state === "ACTIVE" && (
        <span
          style={{
            position: "absolute",
            top: -9,
            left: "50%",
            transform: "translateX(-50%)",
            fontSize: 9,
            background: "#1B5E7B",
            color: "#fff",
            padding: "2px 8px",
            borderRadius: 8,
            whiteSpace: "nowrap",
          }}
        >
          Aktif Kademe
        </span>
      )}
      <div
        style={{
          width: 56,
          height: 56,
          borderRadius: "50%",
          margin: "0 auto 10px",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          fontSize: 26,
          background: tier.state === "LOCKED" ? "#e8eaed" : "#fff",
          border: `3px solid ${style.border}`,
          color: "#1B5E7B",
        }}
      >
        {tier.state === "LOCKED" ? (
          <FaLock color="#94a3b8" size={20} />
        ) : img ? (
          <img src={img} alt="" style={{ width: 34, height: 34 }} />
        ) : tier.state === "EARNED" ? (
          <FaCheck color="#1B5E20" />
        ) : (
          tier.tierNo
        )}
      </div>
      <div style={{ fontSize: 12, fontWeight: 600, color: "#1a1a2e" }}>{tier.name}</div>
      {months && (
        <div style={{ fontSize: 9, color: "#94a3b8", marginTop: 2 }}>{months}</div>
      )}

      {tier.state === "ACTIVE" && (
        <div style={{ width: "100%", height: 4, background: "#e8eaed", borderRadius: 2, margin: "6px 0 4px", overflow: "hidden" }}>
          <div style={{ height: "100%", width: `${tier.percent}%`, background: "#2E7D32", borderRadius: 2 }} />
        </div>
      )}

      <span
        style={{
          fontSize: 9,
          padding: "2px 8px",
          borderRadius: 10,
          fontWeight: 500,
          display: "inline-block",
          background: style.badge.bg,
          color: style.badge.color,
        }}
      >
        {style.badge.text}
      </span>

      <div style={{ fontSize: 9, color: "#94a3b8", marginTop: 4 }}>
        {tier.state === "EARNED" && tier.earnedDate
          ? `${moment(tier.earnedDate).format("D MMMM")}'da kazanıldı`
          : `${tier.progress}/${tier.conditionValue} ${CONDITION_LABELS[tier.conditionType] || ""}`}
      </div>
    </button>
  );
};

const BadgeBlock = ({ badge }) => {
  const [detail, setDetail] = useState(badge.activeTier || badge.tiers?.[0] || null);
  const final = badge.finalTier;

  return (
    <div style={{ background: "#fff", borderRadius: 10, border: "1px solid #e8eaed", marginBottom: 16, overflow: "hidden" }}>
      <div style={{ padding: "14px 18px", borderBottom: "1px solid #f0f2f5" }}>
        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
          <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
            {badge.imageUrl && (
              <img src={badge.imageUrl} alt="" style={{ width: 28, height: 28, borderRadius: 6, objectFit: "cover" }} />
            )}
            <div style={{ fontSize: 14, fontWeight: 600, color: "#1a1a2e" }}>{badge.badgeName} — Kademeler</div>
          </div>
          <span style={{ fontSize: 11, color: "#94a3b8" }}>
            {badge.completedTierCount}/{badge.totalTierCount} kademe
          </span>
        </div>
        {badge.description && (
          <div style={{ fontSize: 12, color: "#64748b", marginTop: 6 }}>{badge.description}</div>
        )}
      </div>

      <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fill, minmax(150px, 1fr))", gap: 14, padding: 18 }}>
        {(badge.tiers || []).map((tier) => (
          <TierCard key={tier.tierId} tier={tier} onClick={() => setDetail(tier)} fallbackImage={badge.imageUrl} />
        ))}
      </div>

      {/* Program Sonu Rozeti */}
      {final && (
        <div style={{ padding: "0 18px 18px", textAlign: "center" }}>
          <div style={{ border: "2px dashed #FFD54F", borderRadius: 10, padding: 16, background: "#FFFDE7" }}>
            <div style={{ fontSize: 28, marginBottom: 6 }}>
              {final.imageUrl || badge.imageUrl ? (
                <img
                  src={final.imageUrl || badge.imageUrl}
                  alt=""
                  style={{ width: 44, height: 44, borderRadius: "50%", objectFit: "cover", display: "inline-block" }}
                />
              ) : (
                <FaStar color={final.state === "EARNED" ? "#F9A825" : "#FFD54F"} />
              )}
            </div>
            <div style={{ fontSize: 13, fontWeight: 600, color: "#F57F17" }}>{final.name}</div>
            {final.description && (
              <div style={{ fontSize: 10, color: "#94a3b8", marginTop: 2 }}>{final.description}</div>
            )}
            <div style={{ fontSize: 10, color: "#94a3b8", marginTop: 2 }}>
              {badge.totalTierCount}/{badge.totalTierCount} kademe tamamlandığında kazanılır
            </div>
            <div style={{ display: "flex", justifyContent: "center", gap: 6, marginTop: 8 }}>
              {Array.from({ length: badge.totalTierCount }).map((_, i) => (
                <div
                  key={i}
                  style={{
                    width: 12,
                    height: 12,
                    borderRadius: "50%",
                    background: i < badge.completedTierCount ? "#90CAF9" : "#e8eaed",
                    border: i < badge.completedTierCount ? "none" : "1px solid #d0d5dd",
                  }}
                />
              ))}
            </div>
            <div style={{ fontSize: 9, color: "#94a3b8", marginTop: 4 }}>
              {badge.completedTierCount}/{badge.totalTierCount} kademe tamamlandı
            </div>
          </div>
        </div>
      )}

      {/* Kademe Detay */}
      {detail && (
        <div style={{ borderTop: "1px solid #f0f2f5", padding: 18 }}>
          <div style={{ fontSize: 13, fontWeight: 600, color: "#1a1a2e", marginBottom: 8 }}>{detail.name} — Detay</div>
          {[
            { icon: "🎯", label: "Hedef", val: `${detail.conditionValue}/${detail.conditionTotal} ${CONDITION_LABELS[detail.conditionType] || ""}` },
            { icon: "📊", label: "Mevcut ilerleme", val: `${detail.progress} / ${detail.conditionValue} (%${detail.percent})` },
            ...(detail.periodBegin
              ? [{ icon: "📅", label: "Dönem", val: `${moment(detail.periodBegin).format("D MMM")} — ${moment(detail.periodEnd).format("D MMM YYYY")}` }]
              : []),
            ...(detail.remainingDays != null && detail.state === "ACTIVE"
              ? [{ icon: "⏳", label: "Kalan süre", val: `${detail.remainingDays} gün` }]
              : []),
          ].map((row, i) => (
            <div key={i} style={{ display: "flex", alignItems: "center", gap: 12, padding: "8px 0", borderBottom: "1px solid #f5f5f5" }}>
              <div style={{ fontSize: 16, width: 28, textAlign: "center" }}>{row.icon}</div>
              <div style={{ fontSize: 12, color: "#64748b", flex: 1 }}>{row.label}</div>
              <div style={{ fontSize: 12, fontWeight: 600, color: "#1a1a2e" }}>{row.val}</div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

const EarnedBadgeCard = ({ badge }) => (
  <div
    style={{
      textAlign: "center",
      padding: "16px 10px",
      borderRadius: 10,
      border: "1px solid #e8eaed",
      background: "#fff",
    }}
  >
    <div
      style={{
        width: 64,
        height: 64,
        borderRadius: "50%",
        margin: "0 auto 10px",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        background: "radial-gradient(circle at 35% 30%, #FFF8E1, #FFECB3, #FFD54F)",
        border: "3px solid #FFD54F",
      }}
    >
      {badge.imageUrl ? (
        <img src={badge.imageUrl} alt="" style={{ width: 38, height: 38, borderRadius: "50%", objectFit: "cover" }} />
      ) : (
        <FaStar color="#F9A825" size={26} />
      )}
    </div>
    <div style={{ fontSize: 12, fontWeight: 600, color: "#1a1a2e" }}>{badge.badgeName}</div>
    {badge.description && (
      <div style={{ fontSize: 9, color: "#94a3b8", marginTop: 2 }}>{badge.description}</div>
    )}
    {badge.earnedDate && (
      <div style={{ fontSize: 9, color: "#94a3b8", marginTop: 4 }}>
        {moment(badge.earnedDate).format("D MMMM YYYY")}'da kazanıldı
      </div>
    )}
  </div>
);

const Badges = () => {
  const [badges, setBadges] = useState(null);
  const [earned, setEarned] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let active = true;
    Promise.all([
      API.get("/badge/tiered/my")
        .then((res) => (active && res?.isHttpSuccess ? res.data || [] : []))
        .catch(() => []),
      API.get("/badge/tiered/myEarned")
        .then((res) => (active && res?.isHttpSuccess ? res.data || [] : []))
        .catch(() => []),
    ]).then(([tiered, earnedSingle]) => {
      if (!active) return;
      setBadges(tiered);
      setEarned(earnedSingle);
      setLoading(false);
    });
    return () => {
      active = false;
    };
  }, []);

  const empty = !loading && (!badges || badges.length === 0) && earned.length === 0;

  return (
    <div className="bg-white rounded shadow-sm p-3 p-md-4">
      <h4 className="mb-3" style={{ fontSize: 18, fontWeight: 700, color: "#1a1a2e" }}>
        Rozetlerim
      </h4>

      {loading && <div style={{ padding: 24, textAlign: "center", color: "#94a3b8" }}>Yükleniyor…</div>}

      {empty && (
        <div style={{ padding: 24, textAlign: "center", color: "#94a3b8" }}>
          Henüz bir rozet programınız bulunmuyor.
        </div>
      )}

      {!loading && badges?.map((badge) => <BadgeBlock key={badge.badgeId} badge={badge} />)}

      {!loading && earned.length > 0 && (
        <div style={{ background: "#fff", borderRadius: 10, border: "1px solid #e8eaed", marginTop: 16, overflow: "hidden" }}>
          <div style={{ padding: "14px 18px", borderBottom: "1px solid #f0f2f5", fontSize: 14, fontWeight: 600, color: "#1a1a2e" }}>
            Kazandığınız Rozetler
          </div>
          <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fill, minmax(140px, 1fr))", gap: 14, padding: 18 }}>
            {earned.map((b) => (
              <EarnedBadgeCard key={b.badgeId} badge={b} />
            ))}
          </div>
        </div>
      )}
    </div>
  );
};

export default Badges;
